<ng-container [formGroup]="keyDatesForm">
  <div class="modal-header">
    <h5 class="modal-title" id="modal-basic-title">Key Dates</h5>
  </div>

  <div class="modal-body container" ngbAutofocus>
    <app-dc-alert-inner></app-dc-alert-inner>
    <div class="form-row">
      <div class="form-group col-lg-1 kdTenor">
        <app-dc-input
          formControlName="kdTenor"
          [id]="'kdTenor'"
          label="Tenor"
          [pattern]="'[0-9]{1,3}[dmywDMYW]{1}'"
          [helpText]="
            'Format is NNNT where NNN is a number and T is a type:<br><br>D = numbers 1 to 365 only<br>M = numbers 1 to 12 only<br>Y = numbers 1 to 99 only<br>W = numbers 1 to 52 only.'
          "
          customErrorMessage="Please use correct formatting e.g. 1D, 3W, 5M, or 2Y"
        ></app-dc-input>
      </div>
      <div class="form-group col-lg-1 kdFrequency">
        <app-dc-select
          formControlName="kdFrequency"
          [labelId]="'kdFrequency'"
          label="Frequency"
          [items]="frequencyItems"
          closeOnSelect="true"
          [searchable]="true"
          [FreeText]="true"
          [clearSelection]="true"
        ></app-dc-select>
      </div>
      <div
        class="form-group col-lg-3 tradingCalendars"
        [hidden]="hideTradingDropdowns"
      >
        <app-dc-select
          formControlName="tradingCalendars"
          [labelId]="'tradingCalendars'"
          label="Trading Calendars"
          [items]="tradingCalendarItemsUse"
          [multiple]="true"
          [checkbox]="true"
          closeOnSelect="true"
          [clearSelection]="true"
        ></app-dc-select>
      </div>
      <div class="form-group col-lg-3 settlementCalendars">
        <app-dc-select
          formControlName="settlementCalendars"
          [labelId]="'settlementCalendars'"
          label="Settlement Calendars"
          [items]="settlementCalendarsItemsUse"
          [multiple]="true"
          [checkbox]="true"
          closeOnSelect="true"
          [clearSelection]="true"
        ></app-dc-select>
      </div>
      <div class="kd-roll-conventions form-row col">
        <label>Roll Convention</label>
        <div
          class="form-group col tradingCalendars tradingRollConvention"
          [hidden]="hideTradingDropdowns"
        >
          <app-dc-select
            formControlName="tradingRollConvention"
            label="Trading"
            [items]="rollConventionItems"
            closeOnSelect="true"
          ></app-dc-select>
        </div>
        <div class="form-group col kdSettlementRollConvention">
          <app-dc-select
            formControlName="settlementRollConvention"
            [labelId]="'settlementRollConvention'"
            label="Settlement"
            [items]="rollConventionItems"
            closeOnSelect="true"
          ></app-dc-select>
        </div>
        <div class="form-group col kdSettlementRollConvention accrualRollConvention" *ngIf="couponType !== 'NONE'">
          <app-dc-select
            formControlName="accrualRollConvention"
            [labelId]="'accrualRollConvention'"
            label="Accrual"
            [items]="rollConventionItems"
            closeOnSelect="true"
          ></app-dc-select>
        </div>
      </div>
    </div>

    <div class="refreshButtonContainer mt-3 mb-3">
      <button
        type="button"
        class="btn btn-outline-primary btn-sm"
        (click)="refresh()"
        [disabled]="refreshing"
        [attr.data-refreshing]="refreshing"
      >
        Refresh
        <app-dc-spinner *ngIf="refreshing"></app-dc-spinner>
      </button>
    </div>

    <div class="form-row labelContainer">
      <div class="col-lg-1">
        <label class="colHeader">Override</label>
      </div>
      <div class="col-lg-2">
        <label class="colHeader">Type</label>
      </div>
      <div class="col-lg-2">
        <label class="colHeader">Date</label>
      </div>
      <div class="col-lg-2">
        <label class="colHeader">From</label>
      </div>
      <div class="col-lg-1">
        <label class="colHeader">Offset</label>
      </div>
      <div class="col-lg-2">
        <label class="colHeader">Calendar</label>
      </div>
      <div class="col-lg-2">
        <label class="colHeader">Roll Convention</label>
      </div>
    </div>

    <div class="keyDatesScrollableContainer">
      <ng-container *ngFor="let row of rowData">
        <app-date-row
          *ngIf="!row.hidden"
          [parentForm]="keyDatesForm"
          [groupName]="row.groupName"
          [groupTitle]="row.groupTitle"
          [key]="row.key"
          [dropdownParent]="'.modal-body'"
          [hideTradingDropdowns]="hideTradingDropdowns"
        ></app-date-row>
      </ng-container>
    </div>

    <div class="separator"></div>
  </div>

  <div class="modal-footer justify-content-right">
    <button 
      type="button" 
      class="btn btn-secondary btn-sm" 
      (click)="cancel()"
      [disabled]="refreshing">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary btn-sm"
      [disabled]="refreshing"
      (click)="save({ recordSnapshot: true })"
    >
      Save
    </button>
  </div>
</ng-container>
